import _defineProperty from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import defaultSetting from '@/settings.js';

import { ref, onMounted } from 'vue';
// 创建粒子类
const MAX_LEN = 200;
export default /*@__PURE__*/_defineComponent({
  __name: 'Particle',
  setup(__props) {
    class Particle {
      constructor(x, y, radius, color, speedX, speedY) {
        _defineProperty(this, "x", void 0);
        _defineProperty(this, "y", void 0);
        _defineProperty(this, "radius", void 0);
        _defineProperty(this, "color", void 0);
        _defineProperty(this, "speedX", void 0);
        _defineProperty(this, "speedY", void 0);
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.color = color;
        this.speedX = speedX;
        this.speedY = speedY;
      }
      draw(ctx) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.fillStyle = this.color;
        ctx.fill();
      }
      update(particles) {
        this.x += this.speedX;
        this.y += this.speedY;
        // 碰撞检测
        for (const particle of particles) {
          if (particle !== this) {
            const distance = Math.sqrt((this.x - particle.x) ** 2 + (this.y - particle.y) ** 2);
            if (distance < this.radius + particle.radius) {
              // 碰撞发生，交换速度
              const tempSpeedX = this.speedX;
              const tempSpeedY = this.speedY;
              this.speedX = particle.speedX;
              this.speedY = particle.speedY;
              particle.speedX = tempSpeedX;
              particle.speedY = tempSpeedY;
            }
          }
        }
      }
    }
    const canvas = ref(null);
    const particles = [];
    const colors = ref(['#3261c8', '#627dc2']);
    // 生成随机整数
    function randomIntFromRange(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    }
    // 生成随机颜色
    function randomColor() {
      return colors.value[Math.floor(Math.random() * colors.value.length)];
    }
    // 限制粒子数量在视图内
    function limitParticlesInView(maxParticles) {
      const particlesInView = particles.filter(particle => {
        return particle.x > 0 && particle.x < canvas.value.width && particle.y > 0 && particle.y < canvas.value.height;
      });
      if (particlesInView.length > maxParticles) {
        // 超过限制时删除多余的粒子
        particles.splice(maxParticles, particlesInView.length - maxParticles);
      }
    }
    // 初始化粒子数组
    function init() {
      for (let i = 0; i < 50; i++) {
        const radius = randomIntFromRange(1, 5);
        const x = randomIntFromRange(radius, window.innerWidth - radius);
        const y = randomIntFromRange(radius, window.innerHeight - radius);
        const color = randomColor();
        const speedX = (Math.random() - 0.5) * 2; // 随机速度在[-1, 1]之间
        const speedY = (Math.random() - 0.5) * 2;
        particles.push(new Particle(x, y, radius, color, speedX, speedY));
      }
    }
    // 动画循环
    function animate() {
      requestAnimationFrame(animate);
      const ctx = canvas.value?.getContext('2d');
      ctx?.clearRect(0, 0, canvas.value.width, canvas.value.height);
      particles.forEach(particle => {
        particle.update(particles);
        particle.draw(ctx);
      });
      limitParticlesInView(MAX_LEN);
    }
    onMounted(() => {
      if (canvas.value && defaultSetting.enableLoginParticle) {
        canvas.value.width = window.innerWidth;
        canvas.value.height = window.innerHeight;
        init();
        animate();
        window.addEventListener('resize', () => {
          canvas.value.width = window.innerWidth;
          canvas.value.height = window.innerHeight;
          init(); // 调整窗口大小时重新初始化粒子数组
        });
        canvas.value.addEventListener('click', event => {
          for (let i = 0; i < 10; i++) {
            let x, y;
            let overlap = false;
            const radius = randomIntFromRange(3, 6);
            do {
              overlap = false;
              x = event.clientX + (Math.random() - 0.5) * 100; // 在点击位置稍微偏移一些
              y = event.clientY + (Math.random() - 0.5) * 100; // 在点击位置稍微偏移一些
              for (const particle of particles) {
                const distance = Math.sqrt((x - particle.x) ** 2 + (y - particle.y) ** 2);
                if (distance < 2 * radius) {
                  overlap = true;
                  break;
                }
              }
            } while (overlap);
            const color = randomColor();
            const speedX = (Math.random() - 0.5) * 4; // 随机速度在[-2, 2]之间
            const speedY = (Math.random() - 0.5) * 4;
            particles.push(new Particle(x, y, radius, color, speedX, speedY));
          }
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("canvas", {
        id: "particleCanvas",
        ref_key: "canvas",
        ref: canvas
      }, null, 512);
    };
  }
});